import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import AuditCard from './AuditCard';
import BreadcrumbHeader from '../../Layout/Breadcrumb/BreadcrumbHeader'
import { getAudit, auditCaseStudyMetrics, updateAudit, sendEmail } from '../../../utils/Audits';


import SidePanelToggle from '../../Layout/Common/SidePanelToggle';
import EditorBox from '../../Layout/Common/EditorBox';
import { getRecommendations } from '../../../utils/Recommendations';

const INITIAL_STATE = {
    audit: null,
    auditId: null,
    loaded: false,
    dropdownOpen: false,
    prevMetrics: {},
    insights: {},
    error: null
}

function Audit(){

    const params = useParams();
    const [state,setState] = useState(INITIAL_STATE)

    const model = useSelector(state => state.site.model)

    const token = useSelector(state => state.session.token)
    const isAdmin = useSelector(state => state.session.isAdmin)
    // const prevAudit = usePrevious(state.audit)
    
    useEffect(() => {
        const auditId = params.auditId
        
        getAudit(token, auditId)
        .then(async(r) => { 
            const { audit, prevMetrics } = r.response

            const { response, error } = await getRecommendations(audit.siteId, audit.yearMonth)

            setState(prevState => ({
                ...prevState,
                auditId,
                audit,
                insights: response?.result,
                prevMetrics,
                token,
                loaded: true
            }))
        })
        .catch(e =>setState(prevState => ({
            ...prevState,
            auditId,
            loaded: false,
            error: e
        })))
    }, [])

    // setTimeout(async() => {
    //     if(prevAudit !== null && prevAudit.note !== state.audit.note){
    //         await setState(prevState => ({
    //             ...prevState,
    //             audit: state.audit
    //         }))
    //         await saveNote(state.audit.note)
    //     }
    // }, 60000)

    const sendAuditEmail = async(override=false) => {
        const { auditId, token } = state

        const {response, error} = await sendEmail(token, auditId, override ? ({emailSiteUsers: true}) : {})

        if(error){
            toast.danger("Something went wrong")
        }

        if(response){
            if(override){
                toast.success("Email have been sent to site user!", {containerId: "defaultToastContainer"})
            } else {
                toast.success("Test email sent to your email!", {containerId: "defaultToastContainer"})
            }
        }

    }

    const setNote = async(html) => await setState(prevState => ({
        ...prevState,
        audit: {
            ...prevState.audit,
            note: html
        }
    }))

    const saveNote = async(html) => {
        const { token, auditId, audit } = state

        await updateAudit(token, auditId, {note: html, timestamp: audit.timestamp})
    }

    const { audit, auditId, prevMetrics, loaded, dropdownOpen, error, insights } = state

    return  <>
        <BreadcrumbHeader prevCrumbs={[{title:"Audits", url:"/audits"}]} title={auditId} />
        <h1 className="page-header">Audit</h1>
        {loaded && <div className="row">
            <div class={`col-xl-9 col-lg-${(isAdmin || (model?.reseller && !model.isAffiliate)) ? "8" : "12"} col-md-12 col-xs-12`}>
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <div class="panel-heading-btn">
                            <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-default" data-click="panel-expand"><i class="fa fa-expand"></i></a>
                            <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-success" data-click="panel-reload"><i class="fa fa-redo"></i></a>
                            <a href="javascript:;" class="btn btn-xs btn-icon btn-circle btn-warning" data-click="panel-collapse"><i class="fa fa-minus"></i></a>
                        </div>
                        <h4 class="panel-title">
                            Audit
                        </h4>
                    </div>
                    <div class="panel-body">
                        <AuditCard insights={insights} audit={audit} version={audit.version} prevMetrics={prevMetrics} showImages={true} />
                    </div>
                </div>
            </div>
            {(isAdmin || (model?.reseller && !model.isAffiliate)) && <div class="col-xl-3 col-lg-4 col-md-12 col-xs-12 d-none d-lg-block">
                <div class="btn-group dropleft pull-right">
                    <button type="button" class="btn btn-primary dropdown-toggle btn-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Options
                    </button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" href="javascript:;" onClick={() => sendAuditEmail()}>Send Test Email</a>
                        <a class="dropdown-item" href="javascript:;" onClick={() => sendAuditEmail(true)}>Send Site User Email</a>
                    </div>
                </div>
                <div className="clearfix"></div>
                <EditorBox onKeyChange={async(html) => await setNote(html)} onBlur={(html) => saveNote(html)} initialContent={audit?.note} />
            </div>}
        </div>}
        {error && <div className="alert alert-danger">
            <p>Audit Error: {error}</p>
        </div>}
        {/* {(isAdmin || model?.reseller) && <SidePanelToggle className="d-block d-sm-block d-md-block d-lg-none">
            <div class="btn-group dropleft pull-right">
                <button type="button" class="btn btn-primary dropdown-toggle btn-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Options
                </button>
                <div class="dropdown-menu">
                    <a class="dropdown-item" href="javascript:;" onClick={() => sendAuditEmail()}>Send Test Email</a>
                </div>
            </div>
            <div className="clearfix"></div>
            <EditorBox onKeyChange={async(html) => await setNote(html)} onBlur={(html) => saveNote(html)} initialContent={audit?.note} />
        </SidePanelToggle>} */}
    </>
}

export default Audit